module.exports = __webpack_public_path__ + "static/media/placeholder-garrafa.21ca5cd8.svg";